/**
 * @flow
 * @relayHash dedbf8ab5027f87372691eba1d9d5a61
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CategoryAddInput = {
  name: string,
  section: string,
  hidden?: ?boolean,
  clientMutationId?: ?string,
};
export type CategoryAddMutationVariables = {|
  input: CategoryAddInput
|};
export type CategoryAddMutationResponse = {|
  +CategoryAdd: ?{|
    +CategoryEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |},
    +error: ?string,
  |}
|};
export type CategoryAddMutation = {|
  variables: CategoryAddMutationVariables,
  response: CategoryAddMutationResponse,
|};
*/


/*
mutation CategoryAddMutation(
  $input: CategoryAddInput!
) {
  CategoryAdd(input: $input) {
    CategoryEdge {
      node {
        id
      }
    }
    error
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CategoryAddInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "CategoryAdd",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CategoryAddInput!"
      }
    ],
    "concreteType": "CategoryAddPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "CategoryEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "CategoryEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Category",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "CategoryAddMutation",
  "id": null,
  "text": "mutation CategoryAddMutation(\n  $input: CategoryAddInput!\n) {\n  CategoryAdd(input: $input) {\n    CategoryEdge {\n      node {\n        id\n      }\n    }\n    error\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CategoryAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "CategoryAddMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3ea933b5e2f4c7d312b19d0b3929fac4';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/CategoryAddMutation.graphql.js